import React, { createContext, useReducer, useEffect } from "react";
import { callApiSaqsFind } from "../services/";
import SaqReducer from "../modules/reducers/saqReducer";

import { FIND_COMPLETED_SAQ_LIST_SUCCESS } from "../modules/types";

export const SaqContext = createContext();

const SaqContextProvider = (props) => {
  const [saqData, dispatch] = useReducer(SaqReducer, []);
  const { children } = props;

  useEffect(() => {
    callApiSaqsFind({ userId: props.userId, status: props.status })
      .then((res) => {
        if (
          (saqData && !saqData.hasOwnProperty("completedSaqList")) ||
          (saqData.completedSaqList &&
            saqData.completedSaqList &&
            saqData.completedSaqList.length !== res.data.data.length)
        ) {
          //console.log("Dispatching");

          dispatch({
            type: FIND_COMPLETED_SAQ_LIST_SUCCESS,
            payload: res.data.data,
          });
        } else {
          //console.log("Not dispatching");
        }
      })
      .catch((error) => {
        console.log("download error", error);
      });
  });

  return (
    <SaqContext.Provider value={{ saqData, dispatch }}>
      {children}
    </SaqContext.Provider>
  );
};

export default SaqContextProvider;
